(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fresh_later_cart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fresh-later-cart')) {
  customElements.define('fresh-later-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.mounted) return;
      this.mounted = true;
      this.onClick = this.clickHandler.bind(this);
      this.onChange = this.changeHandler.bind(this);
      this.onSubmit = event => { if (this.busy || this.stale) event.preventDefault(); };
      this.onPageShow = event => { if (event.persisted) window.location.reload(); };
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('submit', this.onSubmit);
      window.addEventListener('pageshow', this.onPageShow);
      this.setAttribute('data-enhanced', '');
      this.startClock();
    }
    disconnectedCallback() {
      clearInterval(this.clock);
      this.addEventListener && this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('submit', this.onSubmit);
      window.removeEventListener('pageshow', this.onPageShow);
      this.mounted = false;
    }
    clickHandler(event) {
      const button = event.target.closest('[data-step],[data-remove]');
      if (!button || !this.contains(button)) return;
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (this.busy || this.stale || button.disabled) return;
      const item = button.closest('[data-item]');
      const input = item.querySelector('[data-quantity]');
      if (button.hasAttribute('data-remove')) { this.changeQuantity(item.dataset.key, 0, null); return; }
      if (!input || !input.reportValidity()) return;
      const previous = input.value;
      if (button.dataset.step === '1') input.stepUp(); else input.stepDown();
      if (input.value !== previous) this.changeQuantity(item.dataset.key, Number(input.value), input.id);
    }
    changeHandler(event) {
      const input = event.target;
      if (!input.matches('[data-quantity]') || this.busy || this.stale) return;
      if (!input.reportValidity()) return;
      const quantity = Number(input.value);
      if (quantity === Number(input.defaultValue)) return;
      this.changeQuantity(input.closest('[data-item]').dataset.key, quantity, input.id);
    }
    setBusy(active) {
      this.busy = active;
      this.setAttribute('aria-busy', String(active));
      if (active) {
        this.querySelectorAll('button,input').forEach(element => {
          if (!element.disabled) { element.dataset.flBusy = ''; element.disabled = true; }
        });
      } else {
        this.querySelectorAll('[data-fl-busy]').forEach(element => { element.disabled = false; delete element.dataset.flBusy; });
      }
      if (this.stale) this.querySelectorAll('[name="checkout"],[data-quantity],[data-step]').forEach(element => { element.disabled = true; });
    }
    async request(url, options = {}) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 18000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
        const payload = await response.json();
        if (!response.ok || payload.status >= 400) {
          const error = new Error(payload.description || payload.message || this.dataset.error);
          error.rejected = response.status >= 400 && response.status < 500;
          throw error;
        }
        return payload;
      } finally { clearTimeout(timeout); }
    }
    render(html) {
      if (typeof html !== 'string' || !html) throw new Error(this.dataset.error);
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const source = documentFragment.getElementById(this.id);
      const next = source && source.querySelector('[data-flc-content]');
      if (!next) throw new Error(this.dataset.error);
      this.querySelector('[data-flc-content]').replaceChildren(...next.childNodes);
      this.startClock();
    }
    async refresh() {
      const url = new URL(this.dataset.cartUrl, window.location.origin);
      url.searchParams.set('sections', this.dataset.section);
      const result = await this.request(url.toString());
      this.render(result[this.dataset.section]);
    }
    async changeQuantity(key, quantity, focusId) {
      if (this.busy || this.stale || !Number.isInteger(quantity) || quantity < 0) return;
      this.querySelector('[data-error-box]').hidden = true;
      this.querySelector('[data-status]').textContent = this.dataset.busyText;
      this.setBusy(true);
      let completed = false;
      try {
        const sections = [this.dataset.section];
        if (document.getElementById('cart-icon-bubble')) sections.push('cart-icon-bubble');
        const result = await this.request(this.dataset.changeUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections, sections_url: this.dataset.cartUrl })
        });
        completed = true;
        if (result.sections && result.sections[this.dataset.section]) this.render(result.sections[this.dataset.section]); else await this.refresh();
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && result.sections && result.sections['cart-icon-bubble']) {
          const parsed = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
          const replacement = parsed.querySelector('.shopify-section');
          if (replacement) bubble.replaceChildren(...replacement.childNodes);
        }
        this.querySelector('[data-status]').textContent = this.dataset.updated;
        this.dispatchEvent(new CustomEvent('fresh-later:cart-updated', { bubbles: true, detail: { cart: result } }));
      } catch (error) {
        let reconciled = false;
        if (completed || error.rejected) {
          try { await this.refresh(); reconciled = true; } catch (_) {}
        }
        if (!reconciled) this.stale = true;
        this.querySelector('[data-status]').textContent = '';
        this.querySelector('[data-error-text]').textContent = error.message && error.rejected ? error.message : this.dataset.error;
        this.querySelector('[data-error-box]').hidden = false;
      } finally {
        this.setBusy(false);
        if (!this.isConnected) return;
        const target = focusId && this.querySelector('#' + CSS.escape(focusId));
        if (target && !target.disabled) target.focus({ preventScroll: true });
        else if (!this.stale) this.querySelector('.fc-title').focus({ preventScroll: true });
      }
    }
    startClock() {
      clearInterval(this.clock);
      const banner = this.querySelector('[data-countdown]');
      if (!banner) return;
      const stamp = banner.dataset.end.trim();
      if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(stamp)) return;
      const end = Date.parse(stamp);
      const serverNow = Number(banner.dataset.now) * 1000;
      if (!Number.isFinite(end) || !Number.isFinite(serverNow) || end <= serverNow) return;
      const started = performance.now();
      const deadline = new Intl.DateTimeFormat(document.documentElement.lang || 'fr', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(end));
      banner.querySelector('[data-deadline]').textContent = deadline;
      const tick = () => {
        const left = Math.max(0, Math.floor((end - serverNow - (performance.now() - started)) / 1000));
        if (!left) { banner.hidden = true; clearInterval(this.clock); return; }
        const days = Math.floor(left / 86400);
        const display = [Math.floor(left % 86400 / 3600), Math.floor(left % 3600 / 60), left % 60].map(number => String(number).padStart(2, '0')).join(':');
        banner.querySelector('[data-days]').hidden = days === 0;
        banner.querySelector('[data-days] b').textContent = String(days);
        banner.querySelector('[data-time]').textContent = display;
        banner.hidden = false;
      };
      tick();
      this.clock = setInterval(tick, 1000);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fresh_later_header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fresh-later-header')) {
  customElements.define('fresh-later-header', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.dialog = this.querySelector('[data-menu-dialog]');
      this.opener = this.querySelector('[data-open-menu]');
      this.fallback = this.querySelector('[data-menu-fallback]');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.opener.hidden = false;
      this.fallback.hidden = true;
      this.opener.addEventListener('click', () => this.openMenu(), { signal });
      this.querySelector('[data-close-menu]').addEventListener('click', () => this.closeMenu(), { signal });
      this.dialog.addEventListener('close', () => this.restoreMenu(), { signal });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeMenu(); }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target.closest('a')) this.closeMenu();
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.closeMenu();
      }, { signal });
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.headerSection = this.closest('.fl-header-section');
      this.viewportWidth = window.innerWidth;
      this.desktop.addEventListener('change', event => {
        if (event.matches) this.closeMenu();
        this.resetScroll();
      }, { signal });
      window.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateScroll();
        });
      }, { passive: true, signal });
      window.addEventListener('resize', () => {
        if (this.viewportWidth === window.innerWidth) return;
        this.viewportWidth = window.innerWidth;
        this.resetScroll();
      }, { passive: true, signal });
      this.addEventListener('focusin', () => this.resetScroll(), { signal });
      window.addEventListener('pagehide', () => this.closeMenu(), { signal });
      window.addEventListener('pageshow', event => {
        this.resetScroll();
        if (event.persisted) { this.closeMenu(); this.refreshCart(); }
      }, { signal });
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(this)) this.closeMenu(); }, { signal });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateHeight());
        this.resizeObserver.observe(this.querySelector('.flh-bar'));
      }
      this.updateHeight();
      this.resetScroll();
    }
    updateHeight() {
      const height = this.querySelector('.flh-bar').getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      if (this.headerHeight !== height) {
        this.headerHeight = height;
        this.resetScroll();
      }
    }
    scrollPosition() {
      const root = document.scrollingElement || document.documentElement;
      const maximum = Math.max(0, root.scrollHeight - window.innerHeight);
      return { y: Math.max(0, Math.min(window.scrollY, maximum)), maximum };
    }
    resetScroll() {
      this.headerSection?.classList.remove('flh-is-hidden');
      this.lastScrollY = this.scrollPosition().y;
      this.scrollDistance = 0;
      this.scrollDirection = 0;
    }
    updateScroll() {
      const { y, maximum } = this.scrollPosition();
      const delta = y - this.lastScrollY;
      this.lastScrollY = y;
      const active = document.activeElement;
      const keyboardFocus = active && this.contains(active) && active.matches(':focus-visible');
      if (this.desktop.matches || this.dataset.sticky !== 'true' || this.dialog.open || keyboardFocus || y <= this.headerHeight + 8) {
        this.resetScroll();
        return;
      }
      if (window.scrollY < 0 || window.scrollY > maximum) {
        this.scrollDistance = 0;
        this.scrollDirection = 0;
        return;
      }
      if (Math.abs(delta) < .5) return;
      const direction = Math.sign(delta);
      this.scrollDistance = direction === this.scrollDirection ? this.scrollDistance + Math.abs(delta) : Math.abs(delta);
      this.scrollDirection = direction;
      if (this.scrollDistance < 12) return;
      this.headerSection?.classList.toggle('flh-is-hidden', direction > 0);
      this.scrollDistance = 0;
    }
    openMenu() {
      if (this.dialog.open || this.desktop.matches) return;
      this.resetScroll();
      this.dialog.showModal();
      this.opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('flh-menu-is-open');
    }
    closeMenu() {
      if (this.dialog?.open) this.dialog.close();
      this.restoreMenu();
    }
    restoreMenu() {
      this.opener?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('flh-menu-is-open');
      this.resetScroll();
    }
    async refreshCart() {
      try {
        const url = new URL(this.dataset.rootUrl, window.location.origin);
        url.searchParams.set('section_id', 'cart-icon-bubble');
        const response = await fetch(url, { credentials: 'same-origin', signal: this.controller.signal });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('.shopify-section');
        const bubble = this.querySelector('#cart-icon-bubble');
        if (content && bubble && this.isConnected) bubble.replaceChildren(...content.childNodes);
      } catch (_) {}
    }
    disconnectedCallback() {
      this.closeMenu();
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();
})();
